import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import { defineCustomElements } from "@caspio/components/loader";

defineCustomElements(window);

ReactDOM.render(<App />, document.getElementById("root"));
